const defaults = {
    initialized: false,
    filterKey: 'all',
    isLoadMore: false,
};

export default(state = defaults, action) => {
    switch (action.type) {
        case 'TRANSACTION_RECORD_INIT':
            return {...state, isLoadMore: false, initialized: true, ...action.payload};
        case 'TRANSACTION_RECORD_LOAD_MORE':
            return {...state, ...action.payload, records: [...state.records, ...action.payload.records], isLoadMore: true};
        case 'TRANSACTION_RECORD_SET_FITLER':
            let key = action.payload;
            let filter = state.filter.map((item) => {
                item.selected = item.key === key;
                return item;
            });
             return {...state, filter, filterKey: key};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/transactionRecord.js